import React from "react";

export default function Asterisk() {
  return <sup style={{ color: "#d00", fontSize: 18, top: 0 }}>*</sup>;
}
